export default {
  '概况':'概況',
  '展示当前最新数据':'展示當前最新數據',
  '人已参加运动':'人已參加運動',
  '完成任意一项运动':'完成任意一項運動即算參與運動，包括：作業、體鍛、體測、教學、賽事',
  '学生人数':'學生人數',
  '班级数量':'班級數量',
  '教职工数量':'教職工數量',
  '设备数量':'設備數量',
  '加载中':'加載中...',
  '自主锻炼':'自主鍛鍊',
  '数据来源':'數據來源為校內外自由鍛鍊、趣味鍛鍊、競技場場景，不包括作業、賽事等場景',
  '自主锻炼情况':'自主鍛鍊情況',
  '各年级自主锻炼情况':'各年級自主鍛鍊情況',
  '各年级锻炼时长':'各年級鍛鍊時長',
  '各项目锻炼时长':'各項目鍛鍊時長',
  '各年级每日锻炼时长对比':'各年級每日鍛鍊時長對比',
  '各年级锻炼参与趋势':'各年級鍛鍊參與趨勢',
  '国家学生体质健康测试':'國家學生體質健康測試',
  '数据来源为国家学生体质健康测试板块':'數據來源為國家學生體質健康測試板塊',
  '测试人数':'測試人數',
  '成绩分布':'成績分佈',
  '各年级成绩分布':'各年級成績分佈',
  '总分(下拉筛选项目)':'總分(下拉篩選項目)',
  '男生':'男生',
  '女生':'女生',
  '参与率':'參與率',
  '总人数':'總人數',
  '参与人数':'參與人數',
  '参与率（%）':'參與率（%）',
  '人数':'人數',
  '时长(分钟)':'時長(分鐘)',
  '运动时长':'運動時長',
  '分钟':'分鐘',
  '占比':'佔比',
  '总计':'總計',
  '人':'人',
  '参与测试':'參與測試',
  '未参与测试':'未參與測試',
  '优秀':'優秀',
  '良好':'良好',
  '及格':'及格',
  '不及格':'不及格',
  '正常':'正常',
  '低体重':'低體重',
  '超重':'超重',
  '肥胖':'肥胖',
  '(本学年)':'(本學年)',
  '(本学期)':'(本學期)',
  '查看班级数据':'查看班級數據',
  '各班级参与运动情况':'各班級參與運動情況',
  '各班级运动时长':'各班級運動時長',
  '各项目运动时长':'各項目運動時長',
  '各班级每日锻炼时长对比':'各班級每日鍛鍊時長對比',
  '各班级锻炼参与趋势':'各班級鍛鍊參與趨勢',
  '人均':'人均',
  '总数':'總數',
  '各班级成绩分布':'各班級成績分佈',
  '参与运动情况':'參與運動情況',
  '年级':'年級',
  '班级列表':'班級列表',
  '班级详情':'班級詳情',
  '课堂看板':'課堂看板',
  '个人数据':'個人數據',
  '今日活跃':'今日活躍',
  '本周活跃':'本週活躍',
  '查看学生数据':'查看學生數據',
  '自主锻炼人数':'自主鍛鍊人數',
  '每日运动人数':'每日運動人數',
  '每日运动时长':'每日運動時長',
  '运动时长TOP5':'運動時長TOP5',
  '测试概况':'測試概況',
  '各项目平均分':'各項目平均分',
  '年级平均':'年級平均',
  '成绩及格率':'成績及格率',
  '总时长':'總時長',
  '人均时长':'人均時長',
  '学生列表':'學生列表',
  '关键字搜索':'關鍵字搜索',
  '个人画像':'個人畫像',
  '今日运动':'今日運動',
  '班级排名':'班級排名',
  '本周运动':'本週運動',
  '日均时长':'日均時長',
  '运动处方':'運動處方',
  '体质测试结果':'體質測試結果',
  '身体素质评估':'身體素質評估',
  '身体机能':'身體機能',
  '身体素质':'身體素質',
  '身体形态':'身體形態',
  '班级平均':'班級平均',
  '个人运动时长':'個人運動時長',
  '我':'我',
  '我的平均分':'我的平均分',
  '班级平均分':'班級平均分',
  '时长（分钟）':'時長（分鐘）',
}